import { SpartenType, TaasPhData } from '@ps20/bff-models';
import { convertPhTaasBausteinToTarifrisikoschluessel } from '@ps20-frontend/frontend-models';
import {
  buildBasicSalesProductsForShop,
  buildBasicSalesProductsForStrecke,
  parseDatum,
} from '@ps20-frontend/preis-lib';
import { IAppState } from '../../appState';
import {
  selectAnzahlWohnungen,
  selectAnzahlWohnungenEingabe,
} from '../../../app/shared/selectors/anzahlWohnungen.selector';

export function buildTaasPhDataForStrecke(state: IAppState): TaasPhData {
  const phData: TaasPhData = generateBasicTaasPHData(state);
  phData.salesProducts = buildBasicSalesProductsForStrecke(
    state.produkt,
    convertPhTaasBausteinToTarifrisikoschluessel,
  );
  // In Streckentarifierung muss AnzahlWohnung !== 0 sein,
  // andernfalls liefert Taas keinen Preis fuer die Wohnungs-Haftpflichtschutz Zusatzoption
  phData.anzWohnungen = selectAnzahlWohnungenEingabe(state);
  return phData;
}

export function buildTaasPhDataForShop(state: IAppState): TaasPhData {
  const phData: TaasPhData = generateBasicTaasPHData(state);
  phData.salesProducts = buildBasicSalesProductsForShop(
    state.produkt,
    convertPhTaasBausteinToTarifrisikoschluessel,
  );
  phData.anzWohnungen = selectAnzahlWohnungen(state);
  return phData;
}

function generateBasicTaasPHData(state: IAppState): TaasPhData {
  return {
    spartenType: SpartenType.PRIVATHAFTPFLICHT,
    anzVorschaeden: state.vorschaeden.phVorschaeden,
    anzWohnungen: null,
    familienstand: state.versicherungsnehmer.familienstand,
    plzVN: state.risikoort.plz,
    geburtsdatumVN: parseDatum(state.versicherungsnehmer.geburtsdatum),
    salesProducts: null,
    urbeginndatum: state.vertragsoptionen?.urbeginn,
    internerVertragsbezugs: state.taasInfo?.internerVertragsbezugs,
  };
}
